import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import AttachIcon from '@mui/icons-material/AttachFile';
import { Container, AddButton, Title } from './styles';
import { Box } from '@mui/material';

interface Props {
  title: string;
  handleAdd?: () => void;
  handleEdit?: () => void;
  handleAttach?: () => void;
  padding?: string;
}

export const SectionTitle = ({ title, handleAdd, handleEdit, handleAttach, padding }: Props) => {
  return (
    <Container padding={padding}>
      <Title>{title}</Title>
      <Box>
      {!!handleAdd && (
        <AddButton onClick={handleAdd}>
          <AddIcon />
        </AddButton>
      )}
      {!!handleAttach && (
        <AddButton onClick={handleAttach}>
          <AttachIcon style={{ height: 20, width: 20 }} />
        </AddButton>
      )}
        {!!handleEdit && (
          <AddButton onClick={handleEdit}>
            <EditIcon style={{ height: 17, width: 17 }} />
          </AddButton>
        )}
      </Box>
    </Container>
  );
};
